<script setup lang="ts">
import { DialogRoot, type DialogRootEmits, type DialogRootProps, useForwardPropsEmits } from 'reka-ui'

const props = defineProps<DialogRootProps>()
const emits = defineEmits<DialogRootEmits>()

const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
    <DialogRoot data-slot="dialog" v-bind="forwarded" v-slot="slotProps">
        <slot v-bind="slotProps" />
    </DialogRoot>
</template>
